/** @format */

import angular from 'angular';

import template from './gb-presenter.html';
import './gb-presenter.scss';

import screenfull from 'screenfull';

import { map } from 'lodash';

export const GbPresenterComponent = {
    template,
    require: {
        gbApp: '^^',
    },
    controller: class GbPresenterComponent {
        constructor(
            $log,
            $ccToast,
            $gbTextProjectorWidget,
            $gbImageProjectorWidget,
            $gbItemTableProjectorWidget,
            $gbTotalRaisedProjectorWidget,
            $gbNotificationProjectorWidget,
            $gbRaffleDrawProjectorWidget,
            $gbRaffleWinnersProjectorWidget,
            $gbRaffleDraw,
            $gbThermometerProjectorWidget,
            $gbCountdownProjectorWidget,
            $gbTeamScoringProjectorWidget,
            $gbHonourRollProjectorWidget,
            $gbAuctionProfile,
            $q,
            $timeout,
            $scope
        ) {
            'ngInject';

            this.screenfull = screenfull;

            this.$log = $log;
            this.$ccToast = $ccToast;
            this.$gbTextProjectorWidget = $gbTextProjectorWidget;
            this.$gbImageProjectorWidget = $gbImageProjectorWidget;
            this.$gbItemTableProjectorWidget = $gbItemTableProjectorWidget;
            this.$gbTotalRaisedProjectorWidget = $gbTotalRaisedProjectorWidget;
            this.$gbNotificationProjectorWidget = $gbNotificationProjectorWidget;
            this.$gbRaffleDrawProjectorWidget = $gbRaffleDrawProjectorWidget;
            this.$gbRaffleWinnersProjectorWidget = $gbRaffleWinnersProjectorWidget;
            this.$gbThermometerProjectorWidget = $gbThermometerProjectorWidget;
            this.$gbCountdownProjectorWidget = $gbCountdownProjectorWidget;
            this.$gbTeamScoringProjectorWidget = $gbTeamScoringProjectorWidget;
            this.$gbHonourRollProjectorWidget = $gbHonourRollProjectorWidget;
            this.$gbAuctionProfile = $gbAuctionProfile;
            this.$q = $q;
            this.$timeout = $timeout;
            this.$scope = $scope;
            this.$gbRaffleDraw = $gbRaffleDraw;

            this.selectedWidgetId = null;
            this.tempWidgets = [];
            this.isFullscreen = false;
            this.$deselectAllWidgetsEvent = '$deselectAllWidgets';

            this.$saveAllWidgetsTimeout = null;
            this.$saveAllWidgetsDelay = 500;

            this.raffleDrawSpinTime = 5000;

            this.savingWidgets = false;
            this.savingWidget = false;
        }

        fetchAllResources() {
            let Resources = [
                this.$gbTextProjectorWidget,
                this.$gbImageProjectorWidget,
                this.$gbItemTableProjectorWidget,
                this.$gbTotalRaisedProjectorWidget,
                this.$gbNotificationProjectorWidget,
                this.$gbRaffleDrawProjectorWidget,
                this.$gbRaffleWinnersProjectorWidget,
                this.$gbThermometerProjectorWidget,
                this.$gbCountdownProjectorWidget,
                this.$gbTeamScoringProjectorWidget,
                this.$gbRaffleDraw,
                this.$gbHonourRollProjectorWidget,
            ];
            return this.$q.all(map(Resources, (Resource) => this.fetchResource(Resource))).catch((err) => {
                this.$ccToast.error(err);
                throw err;
            });
        }

        fetchResource(Resource, params) {
            let promiseParams = params ? params : { auction: this.gbApp.getAuctionUrl() };
            let promise = Resource.query(promiseParams).$promise;

            return Resource.cache.fromPromise(promise);
        }

        getTextWidgets() {
            return this.$gbTextProjectorWidget.cache.query({
                projector: this.gbApp.getProjectorId(),
            });
        }

        getImageWidgets() {
            return this.$gbImageProjectorWidget.cache.query({
                projector: this.gbApp.getProjectorId(),
            });
        }

        getItemTableWidgets() {
            return this.$gbItemTableProjectorWidget.cache.query({
                projector: this.gbApp.getProjectorId(),
            });
        }

        getTotalRaisedWidgets() {
            return this.$gbTotalRaisedProjectorWidget.cache.query({
                projector: this.gbApp.getProjectorId(),
            });
        }

        getNotificationWidgets() {
            return this.$gbNotificationProjectorWidget.cache.query({
                projector: this.gbApp.getProjectorId(),
            });
        }

        getRaffleDrawWidgets() {
            return this.$gbRaffleDrawProjectorWidget.cache.query({
                projector: this.gbApp.getProjectorId(),
            });
        }

        getRaffleWinnersWidgets() {
            return this.$gbRaffleWinnersProjectorWidget.cache.query({
                projector: this.gbApp.getProjectorId(),
            });
        }

        getThermometerWidgets() {
            return this.$gbThermometerProjectorWidget.cache.query({
                projector: this.gbApp.getProjectorId(),
            });
        }

        getCountdownWidgets() {
            return this.$gbCountdownProjectorWidget.cache.query({
                projector: this.gbApp.getProjectorId(),
            });
        }

        getTeamScoringWidgets() {
            return this.$gbTeamScoringProjectorWidget.cache.query({
                projector: this.gbApp.getProjectorId(),
            });
        }

        getHonourRollWidgets() {
            return this.$gbHonourRollProjectorWidget.cache.query({
                projector: this.gbApp.getProjectorId(),
            });
        }

        getSelectedWidget() {
            return (
                this.$gbTextProjectorWidget.cache.single(this.selectedWidgetId) ||
                this.$gbImageProjectorWidget.cache.single(this.selectedWidgetId) ||
                this.$gbItemTableProjectorWidget.cache.single(this.selectedWidgetId) ||
                this.$gbTotalRaisedProjectorWidget.cache.single(this.selectedWidgetId) ||
                this.$gbNotificationProjectorWidget.cache.single(this.selectedWidgetId) ||
                this.$gbRaffleDrawProjectorWidget.cache.single(this.selectedWidgetId) ||
                this.$gbRaffleWinnersProjectorWidget.cache.single(this.selectedWidgetId) ||
                this.$gbThermometerProjectorWidget.cache.single(this.selectedWidgetId) ||
                this.$gbCountdownProjectorWidget.cache.single(this.selectedWidgetId) ||
                this.$gbTeamScoringProjectorWidget.cache.single(this.selectedWidgetId) ||
                this.$gbHonourRollProjectorWidget.cache.single(this.selectedWidgetId)
            );
        }

        getBackgroundImage() {
            return this.gbApp.getProjector().background_image;
        }

        getBackgroundColor() {
            return this.gbApp.getProjector().background_color;
        }

        getBackgroundSize() {
            return this.gbApp.getProjector().background_image_cover ? 'cover' : '';
        }

        getCombinedWidgets() {
            return this.getTextWidgets().concat(
                this.getImageWidgets(),
                this.getItemTableWidgets(),
                this.getTotalRaisedWidgets(),
                this.getNotificationWidgets(),
                this.getRaffleDrawWidgets(),
                this.getRaffleWinnersWidgets(),
                this.getThermometerWidgets(),
                this.getCountdownWidgets(),
                this.getTeamScoringWidgets()
            );
        }

        getLayerOrderedWidgets() {
            return this.getCombinedWidgets().sort((a, b) => a.z - b.z);
        }

        someWidgetSelected() {
            return !!this.selectedWidgetId;
        }

        selectWidget(widgetId) {
            this.selectedWidgetId = widgetId;
            this.copiedWidget = angular.copy(this.getSelectedWidget());
        }

        getCopiedWidget() {
            return this.copiedWidget;
        }

        widgetSelected(widgetId) {
            return this.selectedWidgetId === widgetId;
        }

        isTextWidget(widget) {
            return widget instanceof this.$gbTextProjectorWidget;
        }

        isImageWidget(widget) {
            return widget instanceof this.$gbImageProjectorWidget;
        }

        isItemTableWidget(widget) {
            return widget instanceof this.$gbItemTableProjectorWidget;
        }

        isTotalRaisedWidget(widget) {
            return widget instanceof this.$gbTotalRaisedProjectorWidget;
        }

        isNotificationWidget(widget) {
            return widget instanceof this.$gbNotificationProjectorWidget;
        }

        isRaffleDrawWidget(widget) {
            return widget instanceof this.$gbRaffleDrawProjectorWidget;
        }

        isRaffleWinnersWidget(widget) {
            return widget instanceof this.$gbRaffleWinnersProjectorWidget;
        }

        isThermometerWidget(widget) {
            return widget instanceof this.$gbThermometerProjectorWidget;
        }

        isCountdownWidget(widget) {
            return widget instanceof this.$gbCountdownProjectorWidget;
        }

        isTeamScoringWidget(widget) {
            return widget instanceof this.$gbTeamScoringProjectorWidget;
        }

        isHonourRollWidget(widget) {
            return widget instanceof this.$gbHonourRollProjectorWidget;
        }

        removeWidget(widget) {
            if (this.selectedWidgetId === widget.uuid) {
                this.selectedWidgetId = null;
                this.copiedWidget = null;
            }

            widget.constructor.cache.remove(widget.uuid);
        }

        deselectAllWidgets() {
            this.selectedWidgetId = null;
            this.copiedWidget = null;
            this.$scope.$broadcast(this.$deselectAllWidgetsEvent);
        }

        startFullscreenWatcher() {
            if (this.screenfull.enabled) {
                this.screenfull.on('change', () => {
                    this.$scope.$apply(() => {
                        this.isFullscreen = !!this.screenfull.isFullscreen;
                    });
                });
            }
        }

        goFullscreen() {
            if (this.screenfull.enabled) {
                this.screenfull.request();
            }
        }

        exitFullscreen() {
            if (this.screenfull.enabled) {
                this.screenfull.exit();
            }
        }

        enterPreviewMode() {
            this.deselectAllWidgets();
            this.goFullscreen();
        }

        setWidgetLayers() {
            let widgets = this.getLayerOrderedWidgets();

            for (let i = 0; i < widgets.length; i++) {
                widgets[i].z = i + 1;
            }
        }

        saveWidget(widget) {
            this.savingWidget = true;
            let widgetCache = widget.constructor.cache;

            return widget
                .$save({
                    auction: this.gbApp.getAuctionUrl(),
                })
                .then((data) => {
                    this.$log.info('Saved Widget', data);
                    widgetCache.push(data);
                    return data;
                })
                .catch((err) => {
                    this.$ccToast.error(err);
                    throw err;
                })
                .finally(() => {
                    this.savingWidget = false;
                });
        }

        saveAllWidgets() {
            this.$saveAllWidgetsPromise = this.$q.defer();

            if (this.$saveAllWidgetsTimeout) {
                this.$timeout.cancel(this.$saveAllWidgetsTimeout);
                this.$saveAllWidgetsTimeout = null;
            }

            this.$saveAllWidgetsTimeout = this.$timeout(() => {
                this.$saveAllWidgets()
                    .then((data) => {
                        this.$saveAllWidgetsPromise.resolve(data);
                    })
                    .catch((err) => {
                        this.$saveAllWidgetsPromise.reject(err);
                    });
            }, this.$saveAllWidgetsDelay);

            return this.$saveAllWidgetsPromise.promise;
        }

        $saveAllWidgets() {
            this.savingWidgets = true;
            let promises = [];

            let saveAll = () => {
                for (let widget of this.getCombinedWidgets()) {
                    promises.push(this.saveWidget(widget));
                }

                return this.$q.all(promises).finally(() => {
                    this.savingWidgets = false;
                });
            };

            if (this.getCopiedWidget()) {
                return this.saveWidget(this.getCopiedWidget()).then(() => saveAll());
            } else {
                return saveAll();
            }
        }

        $onInit() {
            this.fetchAllResources().then(() => {
                this.setWidgetLayers();
            });

            this.startFullscreenWatcher();
        }
    },
};
